'use client'
import { Button } from '@/components/atoms/button'
import { CustomGrid } from '@/components/layout/grid/CustomGrid'
import {
  RichTextComponent,
  RichTextProps,
} from '@/components/molecules/richTextComponent'
import { ButtonVariants, RichTextAlignment } from '@/types/enums'
import { GridItem, VStack } from '@chakra-ui/react'
import { ButtonProps } from '@/baseComponents'

export interface IntroductionProps {
  richTextProps: RichTextProps
  buttonProps?: ButtonProps
}

/**
 * Represents a Introduction component
 * @param richTextProps - Props for rendering a title with richtext.
 * @param buttonProps - Props for rendering a button
 * @returns Introduction
 */
export const Introduction = ({
  richTextProps,
  buttonProps,
}: IntroductionProps) => {
  return (
    <CustomGrid>
      <GridItem colStart={{ base: 1, lg: 2 }} colSpan={{ base: 12, lg: 10 }}>
        <VStack gap={6}>
          <RichTextComponent
            alignment={RichTextAlignment.Center}
            titleProps={{ fontSize: { base: '2xl', md: '2rem', lg: '4xl' } }}
            {...richTextProps}
          />
          {buttonProps?.url && (
            <Button buttonVariant={ButtonVariants.Secondary} {...buttonProps} />
          )}
        </VStack>
      </GridItem>
    </CustomGrid>
  )
}
